<template lang="pug">
.description_detail.i_mlr_auto
  .container.i_mt_5
    .row
      .col-12.text-center
        h5 {{ image.Detail_area01_Title }}
    .row.i_mt_4
      .col-12.text-center
        img.banner(:src="image.Detail_area01_Image")
  media-img.golden_line_up(:imgUrl="'golden_line_up'")
  .container
    .row
      .col-12.text-center.text-lg-left
        h5.ensure_items.i_mt_25 投保須知
    .row
      .col-4
        item(
          :title="image.Detail_area01_Item01Title",
          :subtitle="image.Detail_area01_Item01SubTitle",
          :img="image.Detail_area01_Item01Image"
        )
      .col-4
        item(
          :title="image.Detail_area01_Item02Title",
          :subtitle="image.Detail_area01_Item02SubTitle",
          :img="image.Detail_area01_Item02Image"
        )
      .col-4
        item(
          :title="image.Detail_area01_Item03Title",
          :subtitle="image.Detail_area01_Item03SubTitle",
          :img="image.Detail_area01_Item03Image"
        )
    .row
      .col-12
        span.check_text.i_ml_1 {{ image.Detail_area01_ItemNote }}
  .container.i_mt_5
    .row.i_mt_6.btns.d-none.d-md-flex.justify-content-around.i_ptb_4.i_mlr_4.i_plr_8.i_plr_md_12
      a.btn_round.btn_border_blue_ci(
        v-if="image.Detail_area01_Btn01_URL != null && image.Detail_area01_Btn01_URL != ''",
        :href="image.Detail_area01_Btn01_URL",
        target="_blank"
      ) {{ image.Detail_area01_Btn01_Title }}
      a.btn_round.btn_border_blue_ci(
        v-if="image.Detail_area01_Btn02_URL != null && image.Detail_area01_Btn02_URL != ''",
        :href="image.Detail_area01_Btn02_URL",
        target="_blank"
      ) {{ image.Detail_area01_Btn02_Title }}
      a.btn_round.btn_border_blue_ci(
        v-if="image.Detail_area01_Btn03_URL != null && image.Detail_area01_Btn03_URL != ''",
        :href="image.Detail_area01_Btn03_URL",
        target="_blank"
      ) {{ image.Detail_area01_Btn03_Title }}
      router-link.btn_round(
        v-if="true",
        tag="a",
        :to="{ name: 'CustomerServiceContactUs' }"
      ) 聯絡我們
    .row.i_mt_6.i_mlr_4.d-none.d-md-block
      p.i_body_l.note {{ image.Detail_area01_Note }}
  .container-fluid.bg_blue.i_ptb_8.i_mt_6.d-md-none
    .container
      .row.btns_sm_1.d-flex.justify-content-between
        a.btn_round.btn_border_blue_ci(
          :href="image.Detail_area01_Btn01_URL",
          target="_blank"
        ) {{ image.Detail_area01_Btn01_Title }}
        a.btn_round.btn_border_blue_ci(
          :href="image.Detail_area01_Btn02_URL",
          target="_blank"
        ) {{ image.Detail_area01_Btn02_Title }}
        a.btn_round.btn_border_blue_ci(
          :href="image.Detail_area01_Btn03_URL",
          target="_blank"
        ) {{ image.Detail_area01_Btn03_Title }}

      .row.i_mt_6
        p.i_body_l.note {{ image.Detail_area01_Note }}
      .row.btns_sm_2.justify-content-center
        router-link.btn_round(
          v-if="true",
          tag="a",
          :to="{ name: 'CustomerServiceContactUs' }"
        ) 聯絡我們
</template>

<script>
import MediaImg from "@/components/common/MediaImg";
import Item from "@/components/product/Description/Image/Item";

export default {
  name: "CustomImage",
  props: {
    image: Object,
  },
  components: {
    "media-img": MediaImg,
    item: Item,
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/style/product/description/table";
.description_detail {
  h5 {
    color: $color_blue_ci;
  }
}

img.banner {
  width: 100%;
  height: auto;
}

.golden_line_up {
  width: 100vw;
  height: 10px;
  margin: 70px auto;
  left: 0;
  position: absolute;
}

@media (max-width: 991px) {
  .description_detail {
    h5 {
      font-size: 20px;
    }
  }

  h5.ensure_items {
    font-size: 24px;
  }
}

@media (max-width: 767px) {
  .description_detail {
    h5 {
      font-size: 24px;
    }
  }

  h5.ensure_items {
    font-size: 30px;
  }
}

@media (max-width: 575px) {
  h5.ensure_items {
    font-size: 5.2vw;
  }
}
</style>
